export default {
  login: {
    login: 'サインアップ',
    account: 'アカウント',
    password: 'パスワード',
    remember: '覚えて',
    forget: '忘れる',
    privacy_policy: 'プライバシーポリシー',
    title: 'STAY ログインページ'
  },
  lang: {
    ko: '한국인',
    ja: '日本語',
    zh: '中文(简)',
    'zh-Hant': '中文(繁)',
    en: 'English'
  },
  tip: {
    emptyData: 'データがありません',
    login: 'アカウントとパスワードを空にすることはできません',
    success: '操作成功',
    fail: '操作失敗',
    tip: 'ヒント',
    logout: 'ログアウトするかどうかの確認 ?',
    yes: 'もちろん',
    no: 'キャンセル'
  },
  date: {
    week: {
      0: '日',
      1: '月',
      2: '火',
      3: '水',
      4: '木',
      5: '金',
      6: '土'
    }
  },
  header: {
    areaGuide: 'エリアガイド',
    modelCourses: 'モデルコース',
    travelGuide: '旅行ガイド',
    tickets: 'チケット',
    areaGuideDescription: 'どのエリアにも、それぞれの物語があります',
    modelCoursesDescription:
      'すべての旅行スタイルのためのカスタマイズされたルート',
    travelGuideDescription: '訪問者の実際の体験',
    accessMap: 'アクセスマップ',
    accessMapDescription: '主要都市からのアクセス',
    accessMapTitle: '主要都市からのアクセス',
    accessCities: {
      tokyo: {
        name: '東京から',
        description: 'JR・近鉄特急利用',
        time: '約3時間'
      },
      kyoto: {
        name: '京都から',
        description: '近鉄特急利用',
        time: '約2時間30分'
      },
      osaka: {
        name: '大阪から',
        description: '近鉄特急利用',
        time: '約2時間'
      },
      nagoya: {
        name: '名古屋から',
        description: '近鉄特急利用',
        time: '約1時間30分'
      }
    }
  },
  footer: {
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    specifiedCommercialTransactions: '特定商取引法に基づく表記',
    contact: 'お問い合わせ',
    address: '〒517-0011 三重県鳥羽市鳥羽1-2-3',
    copyright: '© 近畿鉄道'
  },
  article: {
    aboutTheCourse: 'コースについて',
    author: '著者',
    schedule: 'スケジュール',
    recommendedPoints: 'おすすめポイント',
    home: 'ホーム',
    regionalIntroduction: '地域紹介',
    iseCity: '伊勢市',
    iseshi: '伊勢市',
    iseDescription: '日本人の心の故郷である伊勢神宮を中心に栄えた歴史ある町。',
    travelGuide: '旅行ガイド',
    iseSightseeingGourmetGuide: '伊勢観光グルメガイド',
    mustSeeSpots: '必見スポット',
    relatedArticles: '関連記事',
    touristGuide: '観光ガイド',
    basicGuideToVisitingIseJingu: '伊勢神宮参拝の基本ガイド',
    traveler: '旅行者',
    showMore: 'さらに表示'
  },
  home: {
    learnMore: '詳しく見る'
  },
  share: {
    activityCategory: {
      RAILWAY_TICKET: '鉄道チケット',
      AIRPORT_TRANSPORTATION: '空港アクセス',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速バス',
      BUS_TOUR: 'バスツアー',
      CRUISES: 'クルーズ',
      RENTAL_CAR: 'レンタカー',
      CHARTER: 'チャーター',
      ATTRACTION: 'アトラクション',
      THEME_PARK: 'テーマパーク',
      MUSEUM_GALLERY: '美術館・博物館',
      AQUARIUM_ZOO: '水族館・動物園',
      TEMPLES_SHINES: '寺社',
      TOWER_BUILDING: 'タワー・建物',
      JAPANESE_RESTAURANT: '和食',
      WESTERN_RESTAURANT: '洋食',
      CHINESE_RESTAURANT: '中華',
      OTHER_RESTAURANT: 'その他飲食',
      DESSERT_BEVERAGE: 'デザート・ドリンク',
      SIGHTSEEING_TOUR: '観光ツアー',
      MARINE_SPORTS: 'マリンスポーツ',
      OUTDOOR_ACTIVITIES: 'アウトドア',
      ONSEN: '温泉',
      SPA_MASSAGE: 'スパ・マッサージ',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化体験',
      JAPANESE_CRAFT_EXPERIENCE: '日本工芸体験',
      JAPANESE_COOKING_EXPERIENCE: '日本料理体験',
      OTHER_EXPERIENCE: 'その他体験',
      HOTEL: 'ホテル',
      RYOKAN: '旅館',
      VACATION_RENTAL: 'バケーションレンタル',
      BUNDLE: 'セット',
      PASS: 'パス',
      OTHERS: 'その他'
    }
  }
};
